export const CRON_DEFINITIONS_SET_DATA = 'CRON_DEFINITIONS_SET_DATA'
